// Using double quotes in this file to prevent issues with apostrophes (')
export default {
  header: {
    ai: {
      title: 'Demander à HP Nio',
      close: 'Fermer le chat Nio',
      open: 'Ouvrir le chat Nio',
      morningGreeting: "Bonjour {0},",
      afternoonGreeting: "Bonjour {0},",
      eveningGreeting: "Bonsoir {0},",
      morningGreetingGeneric: "Bonjour,",
      afternoonGreetingGeneric: "Bonjour,",
      eveningGreetingGeneric: "Bonsoir,",
      opening: "Je suis Nio. Comment puis-je vous aider ?",
      openingPrivacy: "Je suis Nio.",
      pbIntro1: "Interrogez-moi sur la productivité de votre périphérique.",
      alertDefault: "Je n'en suis qu'au début de mon développement, donc je ne peux pas encore répondre au questions concernant <b>{0}</b>",
      intro2:  "Voici quelques questions qui pourraient vous intéresser :",
      kzIntro1: "Posez-moi vos questions et je vous répondrai en vous fournissant des informations de la Zone de connaissances.",
      pbSample1: "Quelle a été la productivité du site hier ?",
      pbSample2: "Comment améliorer ma productivité ?",
      pbSample3: "Quelle presse est plus performante que les autres ?",
      pbSample4: "Quel type de support qui m’a fait perdre le plus de temps ?",
      pbSample5: "Avec quel problème ai-je perdu le plus de temps la semaine dernière ?",
      kzSample1: "Comment réduire la quantité de déchets de support tout en maintenant la qualité et en réduisant les coûts ?",
      kzSample2: "Quelle HP Indigo Press est la plus efficace et homogène en matière d'impression d'étiquettes de vin ?",
      kzSample3: "Comment optimiser l'utilisation des fournitures pour améliorer la productivité ?",
      kzSample4: "Quels sont les principaux facteurs de développement durable à prendre en compte lors de l'impression ?",
      kzSample5: "Comment assurer la homogénéité des couleurs entre mes HP Indigo 6000 et 20K ?",
      feedbackTitle: "Explication de votre score",
      feedbackPlaceholder: "Pouvez-vous expliquer en détail ce qui s’est passé ?",
      fbPositive1: "Les données sont correctes",
      fbPositive2: "Très bonne réponse",
      fbPositive3: "Très détaillé",
      fbPositive4: "La réponse était pertinente",
      fbOther: "Autre",
      fbNegative1: "Les informations ou données comportent des erreurs",
      fbNegative2: "La réponse ne répondait pas à ma question",
      fbNegative3: "La réponse était confuse ou incompréhensible",
      fbNegative4: "La réponse n’était pas pertinente",
      feedbackSubmittedTitle: "Merci pour votre avis !",
      feedbackSubmittedDescription_Positive: "Nous sommes ravis d’apprendre que la réponse a été utile ! Nous tenons compte de vos retours pour vous offrir de meilleures expériences.",
      feedbackSubmittedDescription_Negative: "Nous nous excusons pour les désagréments occasionnés. Notre équipe passera en revue les informations et mettra tout en œuvre pour vous apporter une solution. Si vous avez plus d’informations sur le problème ou d’autres remarques à faire, n’hésitez pas à nous en faire part pour nous aider à nous améliorer.",
      ask_Placeholder: "Que souhaitez-vous faire maintenant ?",
      answerCopiedToClipboard: "Réponse copiée dans le presse-papiers",
      feedbackSubmitted: "Avis soumis",
      feedbackCleared: "Retour d’expérience supprimé",
      newConversation: "Nouveau Chat",
      chatHistory: "Historique du Chat",
      submitQuestion: "Soumettre une question",
      responseError: "Oups, il semble que nous ayons rencontré un problème de notre côté. Veuillez réessayer plus tard. Si le problème persiste, veuillez contacter l'assistance clientèle.",
      responseError400: "Il semble que votre question contienne des caractères inattendus. Veuillez les supprimer pour continuer.",
      responseError429: "Whoa, ralentissez. Je ne peux pas répondre à autant de questions.",
      like: "J'aime",
      dislike: "Je n'aime pas",
      copy: "Copier dans le presse-papiers",
      retry: "Réessayer",
      contact: "Contactez-nous",
      contactSubject: "Problème avec HP Nio",
      contactQuestion: "Question : {0}",
      noConversations: "Vous n'avez pas de conversation",
      startConversation: "Commencez une conversation pour voir l'historique de votre Chat ici",
      today: "Aujourd'hui",
      yesterday: "Hier",
      privacyNotice: "Vous interagissez avec une solution d’IA.",
      privacy1: "Vous êtes sur le point de vous engager dans une solution d’IA. Les conversations peuvent être analysées et utilisées pour entraîner nos modèles.",
      privacy2: `If you prefer to receive support in another way, please visit {0}.`,
      acceptPrivacy: "Démarrer une conversation avec HP Nio"
    },
    apps: {
      title: "Menu",
      externalLinks: "Externe",
      availableApps: "Explorer",
      configure: "Personnaliser",
      showApp: "Afficher",
      hideApp: "Masquer",
      setDefault: "Définir l'application par défaut",
      setShortcut: "Définir comme épinglé",
      removeShortcut: "Détacher",
      showAllApps: "Afficher toutes les applications",
      shortCutTooltip: "Aller à {0}",
      currentAccount: "Organisation actuelle",
      goHome: "Accéder à l'Accueil",
      goAppHome: "Accéder à la page de démarrage de l'application",
      byProvider: "par {0}",
      quickFilter: "Rechercher une application...",
      allApps: "Toutes les applications",
      recentApps: "Récentes",
      externalApp: "Application externe à PrintOS",
      modeSwitcher: "Mode sombre/clair",
      goProducts: "Explorer d’autres applications"
    },
    panels: {
      ai: "Demander à HP Nio",
      notifications: "Mes notifications",
      help: "Aide et assistance",
      user: "Utilisateur",
      close: "Fermer le panneau",
      moveLeft: "Déplacer vers la gauche",
      moveRight: "Déplacer vers la droite",
      maximize: "Maximiser",
      restore: "Restaurer",
    },
    user: {
      account: "Organisation",
      returnToHP: "Revenir à HP Inc.",
      myOrganization: "Mon organisation",
      myOrganizations: "Mes organisations",
      myReports: "Mes rapports",
      mySettings: "Mes paramètres",
      signOut: "Se déconnecter",
      signInExplanation: "Connectez-vous à HP PrintOS pour afficher vos notifications et vos applications.",
      signIn: "Se connecter",
      RCDA: "Accès client",
      orphanUser: "Utilisateur PrintOS",
      orphanContext: "Aucune organisation",
      deviceUser: "Périphérique PrintOS",
      anonymous: "Utilisateur anonyme",
      name: "Nom",
      email: "E-mail",
      address: "Adresse",
      editUser: "Changer de compte HP",
      viewPrivacy: "Afficher la déclaration de confidentialité"
    },
    date: {
      fewSecondsAgo: "Il y a quelques secondes",
      minuteAgo: "Il y a une minute",
      minutesAgo: "Il y a {0} minutes",
      hourAgo: "Il y a une heure",
      hoursAgo: "Il y a {0} heures",
      dayAgo: "Il y a un jour",
      daysAgo: "Il y a {0} jours",
      monthAgo: "Il y a un mois",
      monthsAgo: "Il y a {0} mois",
      yearAgo: "Il y a un an",
      yearsAgo: "Il y a {0} ans",
    },
    help: {
      quickFilter: "Rechercher",
      page: "Page",
      app: "Application",
      newFeatures: "Nouvelles fonctionnalités",
      more: "Tous",
      contactHP: "Contacter HP",
      noTopics: "Aucune rubrique d’aide correspondante",
      about: "À propos de",
      terms: "Conditions du service",
      readFile: "Document",
      stepByStepTutorial: "Tutoriel",
      goLink: "Page de l’application",
      viewVideo: "Vidéo",
      goToUrl: "Lien",
      other: "Autre",
      faq: "Fréquemment posées",
      new: "Nouvelle rubrique",
      whatsNew: "Nouveautés",
      technicalSupport: "Assistance PrintOS",
      printOSFeedback: "Avis sur PrintOS",
      conversationsWithHP: "Conversations avec HP",
      youMayConsider: "Vous pouvez considérer...",
      myKzArticles: "Mes articles de la Zone de connaissances",
      kzServiceTopics: "{0} ({1})",
      lkcArticles: "Articles du Centre de connaissances HP Latex",
    },
    notifications: {
      noNotifications: "Il n'y a aucune notification",
      viewAll: "Tout afficher",
      dismiss: "Ignorer",
      dismissAll: "Ignorer tout",
      subscriptions: "Paramètres",
    },
    marketplace: {
      title: "Place de marché",
      explore: "Tout explorer",
      featured: "À l'honneur",
      slides: {
        default: {
          description: "Améliorez PrintOS avec des applications, des extensions et des connecteurs Premium"
        },
        oee: {
          title: "TRG (OEE) de Print Beat",
          description: "Atteignez l'excellence opérationnelle avec des renseignements basés sur les données en temps quasi réel",
        },
      },
      partialProductivitySubscribePreEnforcement_Title: "L'accès à Indigo Print Beat, Jobs, OEE et aux services Print Beat nécessitera un abonnement <a href='https:/intercom.help/hp-printos/en/articles/11113950-hp-printos-productivity-power-pack' target='_blank'>Productivity Power Pack</a> à partir du 4 août.",
      partialProductivitySubscribePreEnforcement_Desc: "Les données des périphériques non abonnés peuvent être extraites avant le mois d’août.",
      partialProductivitySubscribePostEnforcement_Title: "Tous vos périphériques Indigo ne sont pas abonnés au Power Pack Productivity ({0}/{1})",
      partialProductivitySubscribePostEnforcement_Desc: "Les périphériques non abonnés peuvent limiter votre expérience PrintOS (Print Beat, Jobs, TRG (OEE), tableaux de bord, etc.)",
      goToMarket_Action: "Accéder à l’application Place de marché",
      howToExtract_Action: "Comment extraire mes données"
    },
    focus: {
      title: "Focus",
    },
    locales: {
      "de-DE": "Allemand",
      "en-GB": "Anglais (GB)",
      "en-US": "Anglais (US)",
      "es-ES": "Espagnol",
      "fr-FR": "Français",
      "it-IT": "Italien",
      "ja-JP": "Japonais",
      "ko-KO": "Coréen",
      "pt-PT": "Portugais",
      "tr-TR": "Turque",
      "zh-HANS": "Chinois (simplifié)",
      "ru-RU": "Russe",
      "Traduction partielle": "Traductions partielles",
    },
    modal: {
      ok: "OK",
      cancel: "Annuler",
    },
    combo: {
      noItems: "Pas de correspondance",
    },
    nps: {
      question: "Bonjour {0}. Seriez-vous prêt à recommander PrintOS à un collègue ?",
      // In case we can't get user's display name
      questionNameless: "Seriez-vous prêt à recommander PrintOS à un collègue ?",
      notLikely: "Pas du tout probable",
      likely: "Très probablement",
      send: "Envoyer un avis",
      response: {
        detractor: "{0}, quel est l’aspect que nous pouvons améliorer pour une meilleure expérience avec PrintOS ? Nous tenons compte de chaque commentaire reçu.",
        detractorNameless: "Quel est l’aspect que nous pouvons améliorer pour une meilleure expérience avec PrintOS ? Nous tenons compte de chaque commentaire reçu.",
        passive: "{0}, faites-nous part de vos conseils pour améliorer l’expérience utilisateur sur PrintOS. Nous tenons compte de chaque commentaire.",
        passiveNameless: "Faites-nous part de vos conseils pour améliorer l’expérience utilisateur sur PrintOS. Nous tenons compte de chaque commentaire.",
        promoter: "{0}, nous sommes ravis que vous appréciiez d’utiliser PrintOS ! Veuillez nous en préciser la raison. Nous tenons compte de chaque commentaire.",
        promoterNameless: "Nous sommes ravis que vous appréciez d’utiliser PrintOS ! Veuillez nous en préciser la raison. Nous tenons compte de chaque commentaire.",
      },
      introMorning: "Bonjour {0}, je suis Jon, le Responsable de la réussite client de PrintOS.",
      introMorningNameless: "Bonjour, je suis Jon, le Responsable de la réussite client de PrintOS.",
      introAfternoon: "Bon après-midi {0}, je suis Jon, le Responsable de la réussite client de PrintOS.",
      introAfternoonNameless: "Bon après-midi, je suis Jon, le Responsable de la réussite client de PrintOS.",
      introEvening: "Bonsoir {0}, je suis Jon, le Responsable de la réussite client de PrintOS.",
      introEveningNameless: "Bonsoir, je suis Jon, le Responsable de la réussite client de PrintOS.",
      intro2: "Veuillez m'aider à comprendre votre expérience sur PrintOS en répondant à cette question :",
      intro3: "Seriez-vous prêt à recommander PrintOS à un collègue ?",
      detractorResponse: "Merci pour votre réponse, {0} ! Nous apprécions autant les avis positifs que les critiques.",
      detractorResponseNameless: "Merci pour votre réponse ! Nous apprécions autant les avis positifs que les critiques.",
      promoterResponse: "Merci {0} ! Nous sommes ravis d’apprendre que vous êtes enthousiasmé par PrintOS. Votre avis nous aidera toujours à vous offrir la meilleure expérience possible.",
      promoterResponseNameless: "Merci ! Nous sommes ravis d’apprendre que vous êtes enthousiasmé par PrintOS. Votre avis nous aidera toujours à vous offrir la meilleure expérience possible.",
      response2: "Veuillez choisir une application et nous dire comment nous pourrions améliorer PrintOS pour vous.",
      response3: "Tous les avis sont examinés par l’équipe de la réussite client. Pour mieux comprendre vos avis, nous pouvons éventuellement vous contacter.",
      feedbackPlaceholder: "Vous pouvez améliorer PrintOS en...",
      application: "Application",
      noApplication: "PrintOS - Avis généraux"
    },
    subscription: {
      title: "Abonnement",
      subscribe: "S’inscrire maintenant !",
      noticeSingular: "Votre abonnement pour {0} expire dans {1} jour.",
      notice: "Votre abonnement pour {0} expire dans {1} jours.",
    },
    promotion: {
      label: "Promotion",
      title: "Notice sur la période promotionnelle",
      notice: "Vous êtes dans une période promotionnelle pour cette application.",
    },
    trial: {
      label: "La version d'essai expire bientôt",
      title: "Période d’essai",
      noticeSingular: "{0} correspond à une période d'essai. Votre période d'essai expire dans {1} jour.",
      notice: "{0}  correspond à une période d'essai. Votre période d'essai expire dans {1} jours.",
    },
    subscriptionExpired: {
      label: "L'abonnement a expiré",
      title: "L'abonnement a expiré",
      notice: "Votre abonnement pour {0} a expiré.  Après un court délai de grâce, vous ne pourrez plus accéder à cette fonctionnalité.",
    },
    trialExpired: {
      label: "Essai expiré",
      title: "Période d’essai expirée",
      notice: "Votre période d'essai pour {0} a expiré.  Après un court délai de grâce, vous ne pourrez plus accéder à cette fonctionnalité.",
    },
    hpWarning: "{0}\nVous êtes un représentant HP Inc. dans une organisation cliente. Veuillez être prudent.",
    role: {
      HP_Operation: "HP - Opération",
      HP_Sales_and_Marketing: "Contact direct avec le client HP",
      SystemRoleGenesis_Admin: "Page d'administration du service PrintOS",
      SystemRoleGenesis_Support: "Administrateur HP Inc.",
      SystemRoleGenesis_R_AND_D: "Genesis - Recherche et développement",
      CE_Level_1: "Niveau CE 1",
      CE_Level_2: "Niveau CE 2",
      Application_Engineer: "Ingénieur de l'application",
      Ramp_Up_Engineer: "Ingénieur chargé de la montée en cadence",
      Support_Engineer: "Ingénieur d'assistance",
      Remote_Support_Engineer: "Ingénieur d'assistance HP",
      Specialist: "Spécialiste",
      Certification_Centers: "Centres de certifications",
      Supplies_and_Media_Personnel: "Personnel pour les consommables et les supports",
      Supplies_and_Media_Admin: "Administrateur des consommables et des supports",
      HP_Service: "Service de HP",
      HP_Training: "Formation de HP",
      Admin: "Administrateur",
      Pre_Press_Operator: "Utilisateur",
      Press_Operator: "Opérateur",
      Dashboard: "Tableau de bord",
      Channel_Sales_and_Marketing: "Distribution - Ventes et marketing",
      Channel_Operation: "Exploitation de distribution",
      Channel_CE_Level_1: "Niveau 1 du canal CE",
      Channel_CE_Level_2: "Niveau 2 du canal CE",
      HP_Read_Only: "Lecture par HP uniquement",
      Reseller_Manager: "Responsable des revendeurs",
      Business_Partner_Manager: "Responsable des partenaires commerciaux",
      Call_Center: "Centre d'appels",
      Field_Engineer: "Ingénieur en prospection",
      ThreeD_Business_Manager: "Responsable commercial 3D",
      HPInPsp: "HP dans PSP",
      ChannelInPsp: "Canal dans PSP",
      GenericAdmin: "Administrateur",
      GenericUser1: "Niveau utilisateur 1",
      GenericUser2: "Niveau utilisateur 2",
      Generic_Read_Only: "Lecture uniquement",
      ThreeD_Care_Center: "3D Care Center",
      ThreeD_Cost_Calculator: "Coûts 3D",
      Composer_External: "Accès limité - Composeur",
      SIM_External: "Accès limité - Gestionnaire d’inventaire de consommables",
      Multiple: "Rôles multiples"
    },
    inlineAlerts: {
      Http_429_Error: "Trafic important",
      Http_429_Description: "Le service connaît actuellement des charges anormales. Certaines fonctionnalités peuvent être temporairement indisponibles. Actualisez la page pour réessayer",
      Http_429_Action: "Actualiser",
      NewSubscription: "Nouvel abonnement - {0}",
      NewSubscriptionDescription: "Votre organisation dispose d’un abonnement",
      NewSubscriptionAction: "En apprendre davantage",
      SubscriptionExpired: "Abonnement expiré - {0}",
      SubscriptionExpiredDescription: "Votre abonnement a expiré le {0}",
      SubscriptionExpiredAction: "Afficher l'abonnement",
      Subscription30DayWarning: "L’abonnement va expirer - {0}",
      Subscription30DayWarningDescription: "Votre abonnement va expirer dans {0} jours, le {1}",
      Subscription30DayWarningAction: "Afficher l'abonnement",
      Subscription15DayWarning: "L’abonnement expire bientôt - {0}",
      Subscription15DayWarningDescription: "Votre abonnement va expirer dans {0} jours, le {1}",
      Subscription15DayWarningAction: "Afficher l'abonnement",
      JoinOrgRequestAccepted: "Demande d’adhésion à une organisation acceptée",
      JoinOrgRequestAcceptedDescription: "Vous avez obtenu l’accès à <b>{0}</b>",
      JoinOrgRequestSwitch: "Ouvrir l’organisation",
      JoinOrgRequestDenied: "Demande d’adhésion à une organisation refusée",
      JoinOrgRequestDeniedDescription: "L’administrateur a refusé votre demande d’adhésion à <b>{0}</b>",
      NonHPContext: "Ouvrir le contexte non hp",
      NonHPContextDescription: "Contexte : {0}",
      CloseContext: "Fermer le contexte"
    },
    ui: {
      Confirm: "Confirmer",
      Notify: "Notification",
      OpenImage: "Ouvrir le fichier image",
      Dismiss: "Ignorer",
      CheckingContext: "Vérification du contexte...",
      LoadingContext: "Restauration de {0}..."
    }
  }
};
